import { apiService } from '@/api/apiService'
import { fetchingAPI } from '@/api/fetchingAPI'

import { getKodiHost } from '../kodi.constants'

// The backend still serves Kodi Reports from its original /dashboard routes.
const chartsUrl = () => `${window.location.protocol}//${getKodiHost()}/dashboard/charts`

const chartUrl = (cardId) => `${chartsUrl()}/${encodeURIComponent(cardId)}`

// The viewer's own charts and ones shared with them by name, for the My reports tab.
export const listReportCharts = (dispatch) => {
  return fetchingAPI(`${chartsUrl()}/mine`, 'GET', dispatch)
}

// Every chart shared with the whole org, for the Public reports tab.
export const listPublicReportCharts = (dispatch) => {
  return fetchingAPI(`${chartsUrl()}/org`, 'GET', dispatch)
}

export const pinReportChart = (dispatch, { title, plan, chartIndex = 0 }) => {
  return fetchingAPI(
    chartsUrl(),
    'POST',
    dispatch,
    JSON.stringify({ title, plan, chart_index: chartIndex })
  )
}

export const renameReportChart = (dispatch, cardId, title) => {
  return fetchingAPI(chartUrl(cardId), 'PATCH', dispatch, JSON.stringify({ title }))
}

// Make a chart private, share it with chosen people (viewerIds), or share it with
// the org.
export const setReportChartVisibility = (dispatch, cardId, visibility, viewerIds) => {
  return fetchingAPI(
    chartUrl(cardId),
    'PATCH',
    dispatch,
    JSON.stringify(viewerIds ? { visibility, viewer_ids: viewerIds } : { visibility })
  )
}

// The org's Balto Cloud users (active, with a login): who a chart can be shared with.
export const listShareableUsers = (dispatch, organizationId) => {
  return fetchingAPI(
    `${apiService.core}/api/organizations/${organizationId}/users?managers=true`,
    'GET',
    dispatch
  )
}

export const deleteReportChart = (dispatch, cardId) => {
  return fetchingAPI(chartUrl(cardId), 'DELETE', dispatch)
}

// The viewer's last result for the chart; the backend re-runs it only when that
// result is missing or over a day old.
export const getReportChartData = (dispatch, cardId) => {
  return fetchingAPI(`${chartUrl(cardId)}/data`, 'GET', dispatch)
}

// Re-runs the chart now. Rejects with status 429 inside the refresh cooldown.
export const refreshReportChart = (dispatch, cardId) => {
  return fetchingAPI(`${chartUrl(cardId)}/refresh`, 'POST', dispatch)
}
